import React, { ReactNode, useEffect, useState } from 'react';
import { AppConfiguration, ConfigContext } from './ConfigContext';

interface ConfigProviderProps {
  children: ReactNode;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  const [config, setConfig] = useState<AppConfiguration | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // Load configuration from static file
        const response = await fetch('/config/config.json');
        if (!response.ok) {
          throw new Error('Failed to load configuration');
        }
        const loadedConfig = await response.json();
        setConfig(loadedConfig);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error occurred'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchConfig();
  }, []);

  if (!config) {
    return null;
  }

  return <ConfigContext.Provider value={{ config, isLoading, error }}>{children}</ConfigContext.Provider>;
};
